import axios from 'axios';
import { V1_CLONE_OUTLET, V1_CLONE_OUTLET_FEATURE_FLAG } from './constants';

function reject(error) {
  let eobj;
  if (error.response) {
    const { data } = error.response;
    if (data.errors) {
      eobj = new Error(data.errors);
    } else if (data.code === '0063-0002') {
      eobj = new Error(data.code);
    } else if (data.error) {
      eobj = new Error(data.error[0]);
    } else if (data.message) {
      eobj = new Error(data.message);
    } else {
      eobj = new Error(error.message);
    }
  } else {
    eobj = new Error(error.message);
  }
  return Promise.reject(eobj);
}

export function submitCloneOutlet(data) {
  return axios
    .post(V1_CLONE_OUTLET, data, { withCredentials: true })
    .catch(reject);
}

export function getProgress() {
  return axios.get(V1_CLONE_OUTLET, { withCredentials: true }).catch(reject);
}

export function deleteCache() {
  return axios.delete(V1_CLONE_OUTLET, { withCredentials: true }).catch(reject);
}

export function isEligible() {
  return axios
    .get(V1_CLONE_OUTLET_FEATURE_FLAG, { withCredentials: true })
    .catch(reject);
}
